var _style, _rect, _polygon, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.5;fill:#606060;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 100,
    height: 100
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "100,7.1 57.1,50 100,92.9 100,100 92.9,100 50,57.1 7.1,100 0,100 0,92.9 42.9,50 0,7.1 0,0 7.1,0  50,42.9 92.9,0 100,0 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,0v100h100V0H0z M90,90H10V10h80V90z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholder);
export default __webpack_public_path__ + "static/media/placeholder.a7f63c13ea49337cdc956e58cbdeda39.svg";
export { ForwardRef as ReactComponent };